import { PropsWithChildren } from 'react';

import styles from './Background.module.scss';

type BackgroundProps = PropsWithChildren;

export const Background = ({ children }: BackgroundProps) => (
  <section className={styles.container}>{children}</section>
);
